import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse } from 'app/types-shared';
import { endpoints } from './endpoints';
import { FavouriteAdminListWire } from './types';
import { 
  FavouriteSearchModel, LoadListRequest, ChangeOwnerRequest, UpdateOwnersRequest, ChangeSharingRequest 
} from './types-store';

const postOwnersChange = async (
  endpoint: string,
  payload: {
    searchParameters: FavouriteSearchModel; applyOnDescendants?: boolean;
    owners?: number[]; toOwners?: number[]; fromOwners?: number[];
  }
) => {
  const request = await new RemoteAdminData(endpoint)
    .resource<ApiResponse<any>>()
    .create(payload);

  return request.data;
};

const postSharingChange = async (endpoint: string, { replace, id, applyOnDescendants, data }: ChangeSharingRequest) => {
  const request = await new RemoteAdminData(endpoint)
    .resource<ApiResponse<any>>()
    .filter({
      replace: !!replace,
      id: id ?? null,
      applyOnDescendants
    })
    .create(data);

  return request.data;
};

export const api = {

  loadList: async ({ model, startIndex, maxResults }: LoadListRequest): Promise<FavouriteAdminListWire> => {

    const response = await new RemoteAdminData(endpoints.searchFavourites)
      .resource<Response>()
      .filter({
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults })
      })
      .create(model, false);

    const json = await response.json();

    return json.data;
  },

  deleteFavourite: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.deleteFavourite)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  },

  changeOwner: ({ owner, toOwners, applyOnDescendants, searchParameters }: ChangeOwnerRequest) =>
    postOwnersChange(endpoints.changeOwner, { searchParameters, fromOwners: [owner], toOwners, applyOnDescendants }),

  addOwner: ({ owners, applyOnDescendants, searchParameters }: UpdateOwnersRequest) =>
    postOwnersChange(endpoints.addOwner, { searchParameters, owners, applyOnDescendants }),

  changeUserGroups: (request: ChangeSharingRequest) => postSharingChange(endpoints.changeUserGroups, request),

  changeUsers: (request: ChangeSharingRequest) => postSharingChange(endpoints.changeUsers, request)
};
